var map = {
	"./assets/calculator-slider-styles.css": 709,
	"./assets/colors.scss": 1975,
	"./assets/default.scss": 404,
	"./assets/fonts/MDI/materialdesignicons-webfont.eot": 1976,
	"./assets/fonts/MDI/materialdesignicons-webfont.ttf": 1977,
	"./assets/fonts/MDI/materialdesignicons-webfont.woff": 1978,
	"./assets/fonts/MDI/materialdesignicons-webfont.woff2": 1979,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Black.eot": 1980,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-BlackItalic.eot": 1981,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Bold.eot": 270,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-BoldItalic.eot": 1982,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Condensed.eot": 1983,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBlack.eot": 1984,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBlackItalic.eot": 1985,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBold.eot": 1986,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedBoldItalic.eot": 1987,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraBold.eot": 1988,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraBoldItalic.eot": 1989,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraLight.eot": 1990,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedExtraLightItalic.eot": 1991,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedHeavy.eot": 1992,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedHeavyItalic.eot": 1993,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedItalic.eot": 1994,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedLight.eot": 1995,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedLightItalic.eot": 1996,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedMedium.eot": 1997,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedMediumItalic.eot": 1998,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSemiBold.eot": 1999,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSemiBoldItalic.eot": 2000,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSuperHeavy.eot": 2001,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedSuperHeavyItalic.eot": 2002,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedThin.eot": 2003,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedThinItalic.eot": 2004,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedUltraBold.eot": 2005,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-CondensedUltraBoldItalic.eot": 2006,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraBold.eot": 2007,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraBoldItalic.eot": 2008,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraLight.eot": 255,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ExtraLightItalic.eot": 2009,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Heavy.eot": 2010,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-HeavyItalic.eot": 2011,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Italic.eot": 2012,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Light.eot": 258,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-LightItalic.eot": 2013,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Medium.eot": 261,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-MediumItalic.eot": 2014,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Regular.eot": 273,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SemiBold.eot": 264,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SemiBoldItalic.eot": 2015,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SuperHeavy.eot": 2016,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-SuperHeavyItalic.eot": 2017,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-Thin.eot": 252,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-ThinItalic.eot": 2018,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-UltraBold.eot": 267,
	"./assets/fonts/anjoman/eot/Anjoman-FaNum-UltraBoldItalic.eot": 2019,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Black.woff": 2020,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-BlackItalic.woff": 2021,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Bold.woff": 272,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-BoldItalic.woff": 2022,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Condensed.woff": 2023,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBlack.woff": 2024,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBlackItalic.woff": 2025,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBold.woff": 2026,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedBoldItalic.woff": 2027,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraBold.woff": 2028,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraBoldItalic.woff": 2029,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraLight.woff": 2030,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedExtraLightItalic.woff": 2031,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedHeavy.woff": 2032,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedHeavyItalic.woff": 2033,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedItalic.woff": 2034,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedLight.woff": 2035,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedLightItalic.woff": 2036,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedMedium.woff": 2037,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedMediumItalic.woff": 2038,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSemiBold.woff": 2039,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSemiBoldItalic.woff": 2040,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSuperHeavy.woff": 2041,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedSuperHeavyItalic.woff": 2042,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedThin.woff": 2043,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedThinItalic.woff": 2044,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedUltraBold.woff": 2045,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-CondensedUltraBoldItalic.woff": 2046,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraBold.woff": 2047,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraBoldItalic.woff": 2048,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraLight.woff": 257,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ExtraLightItalic.woff": 2049,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Heavy.woff": 2050,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-HeavyItalic.woff": 2051,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Italic.woff": 2052,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Light.woff": 260,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-LightItalic.woff": 2053,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Medium.woff": 263,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-MediumItalic.woff": 2054,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Regular.woff": 275,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SemiBold.woff": 266,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SemiBoldItalic.woff": 2055,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SuperHeavy.woff": 2056,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-SuperHeavyItalic.woff": 2057,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-Thin.woff": 254,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-ThinItalic.woff": 2058,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-UltraBold.woff": 269,
	"./assets/fonts/anjoman/woff/Anjoman-FaNum-UltraBoldItalic.woff": 2059,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Black.woff2": 2060,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-BlackItalic.woff2": 2061,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Bold.woff2": 271,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-BoldItalic.woff2": 2062,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Condensed.woff2": 2063,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBlack.woff2": 2064,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBlackItalic.woff2": 2065,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBold.woff2": 2066,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedBoldItalic.woff2": 2067,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraBold.woff2": 2068,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraBoldItalic.woff2": 2069,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraLight.woff2": 2070,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedExtraLightItalic.woff2": 2071,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedHeavy.woff2": 2072,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedHeavyItalic.woff2": 2073,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedItalic.woff2": 2074,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedLight.woff2": 2075,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedLightItalic.woff2": 2076,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedMedium.woff2": 2077,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedMediumItalic.woff2": 2078,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSemiBold.woff2": 2079,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSemiBoldItalic.woff2": 2080,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSuperHeavy.woff2": 2081,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedSuperHeavyItalic.woff2": 2082,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedThin.woff2": 2083,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedThinItalic.woff2": 2084,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedUltraBold.woff2": 2085,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-CondensedUltraBoldItalic.woff2": 2086,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraBold.woff2": 2087,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraBoldItalic.woff2": 2088,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraLight.woff2": 256,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ExtraLightItalic.woff2": 2089,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Heavy.woff2": 2090,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-HeavyItalic.woff2": 2091,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Italic.woff2": 2092,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Light.woff2": 259,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-LightItalic.woff2": 2093,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Medium.woff2": 262,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-MediumItalic.woff2": 2094,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Regular.woff2": 274,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SemiBold.woff2": 265,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SemiBoldItalic.woff2": 2095,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SuperHeavy.woff2": 2096,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-SuperHeavyItalic.woff2": 2097,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-Thin.woff2": 253,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-ThinItalic.woff2": 2098,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-UltraBold.woff2": 268,
	"./assets/fonts/anjoman/woff2/Anjoman-FaNum-UltraBoldItalic.woff2": 2099,
	"./assets/fonts/fonts.css": 405,
	"./assets/images/404.png": 2100,
	"./assets/images/404.svg": 402,
	"./assets/images/504.png": 403,
	"./assets/images/AboutUs/10.png": 1305,
	"./assets/images/AboutUs/AboutUs.png": 1683,
	"./assets/images/AboutUs/CDN.svg": 1684,
	"./assets/images/AboutUs/Colocation.svg": 1685,
	"./assets/images/AboutUs/about-header.svg": 1686,
	"./assets/images/AboutUs/analytics.svg": 1687,
	"./assets/images/AboutUs/budget.svg": 1688,
	"./assets/images/AboutUs/consulting.svg": 1689,
	"./assets/images/AboutUs/container.svg": 1690,
	"./assets/images/AboutUs/contract.svg": 1691,
	"./assets/images/AboutUs/cost.svg": 1692,
	"./assets/images/AboutUs/demo.svg": 1693,
	"./assets/images/AboutUs/header.svg": 1694,
	"./assets/images/AboutUs/history.png": 1695,
	"./assets/images/AboutUs/license.svg": 1696,
	"./assets/images/AboutUs/mission.png": 1697,
	"./assets/images/AboutUs/missionicon.png": 1698,
	"./assets/images/AboutUs/pop.svg": 1699,
	"./assets/images/AboutUs/sazman.svg": 1700,
	"./assets/images/AboutUs/security.svg": 1701,
	"./assets/images/AboutUs/uptime.svg": 1702,
	"./assets/images/ContactUs/1.png": 1794,
	"./assets/images/ContactUs/2.png": 1795,
	"./assets/images/ContactUs/3.png": 1796,
	"./assets/images/ContactUs/4.png": 1797,
	"./assets/images/ContactUs/5.png": 1798,
	"./assets/images/ContactUs/Blog.svg": 1799,
	"./assets/images/ContactUs/ContactUs.png": 1800,
	"./assets/images/ContactUs/ContactUsicon.png": 1801,
	"./assets/images/ContactUs/Location.svg": 1802,
	"./assets/images/ContactUs/Question.svg": 1803,
	"./assets/images/ContactUs/Video.svg": 1804,
	"./assets/images/ContactUs/facebook.svg": 1805,
	"./assets/images/ContactUs/header.svg": 1549,
	"./assets/images/ContactUs/instagram.svg": 1806,
	"./assets/images/ContactUs/linkedin.svg": 1807,
	"./assets/images/ContactUs/mail.svg": 1553,
	"./assets/images/ContactUs/map-m.svg": 1808,
	"./assets/images/ContactUs/map.svg": 1809,
	"./assets/images/ContactUs/person.svg": 1550,
	"./assets/images/ContactUs/phone.svg": 1425,
	"./assets/images/ContactUs/pointer.svg": 1554,
	"./assets/images/ContactUs/support.svg": 1552,
	"./assets/images/ContactUs/telegram.svg": 1810,
	"./assets/images/ContactUs/ticket.svg": 1551,
	"./assets/images/ContactUs/twitter.svg": 1811,
	"./assets/images/ContactUs/youtube.svg": 1812,
	"./assets/images/MainSlider-ld/1.png": 2101,
	"./assets/images/MainSlider-ld/2.png": 2102,
	"./assets/images/MainSlider-ld/3.png": 2103,
	"./assets/images/MainSlider-ld/4.png": 2104,
	"./assets/images/MainSlider-ld/Main.png": 2105,
	"./assets/images/MainSlider/1.png": 2106,
	"./assets/images/MainSlider/2.png": 2107,
	"./assets/images/MainSlider/3.png": 2108,
	"./assets/images/MainSlider/4.png": 2109,
	"./assets/images/MainSlider/Cloud-migration.jpg": 2110,
	"./assets/images/MainSlider/Cloud-migration.webp": 1410,
	"./assets/images/MainSlider/Main.png": 2111,
	"./assets/images/MainSlider/Slider.png": 2112,
	"./assets/images/MainSlider/XaaSSliderPlaformKubernetes.svg": 2113,
	"./assets/images/MainSlider/XaaSSliderPlaformKubernetes1.svg": 2114,
	"./assets/images/MainSlider/x-background.svg": 2115,
	"./assets/images/MainSlider/xaas-logo.svg": 1666,
	"./assets/images/ManagedService/Adobe.svg": 1137,
	"./assets/images/ManagedService/Atlassia.svg": 1138,
	"./assets/images/ManagedService/Big.svg": 1139,
	"./assets/images/ManagedService/Bugzilla.svg": 1140,
	"./assets/images/ManagedService/Cpanel.svg": 1141,
	"./assets/images/ManagedService/Customers/Etebar-gary.png": 868,
	"./assets/images/ManagedService/Customers/Etebar.png": 869,
	"./assets/images/ManagedService/Customers/Mapna-gray.png": 870,
	"./assets/images/ManagedService/Customers/Sina- gray.png": 871,
	"./assets/images/ManagedService/Customers/Sina.png": 872,
	"./assets/images/ManagedService/Customers/afam-color.png": 873,
	"./assets/images/ManagedService/Customers/afam-gray.png": 874,
	"./assets/images/ManagedService/Customers/banner-eseminar.webp": 875,
	"./assets/images/ManagedService/Customers/banner-helal.webp": 876,
	"./assets/images/ManagedService/Customers/banner-kale.webp": 877,
	"./assets/images/ManagedService/Customers/banner-mapna.webp": 878,
	"./assets/images/ManagedService/Customers/bime.webp": 879,
	"./assets/images/ManagedService/Customers/eseminar-d.webp": 880,
	"./assets/images/ManagedService/Customers/eseminar.webp": 881,
	"./assets/images/ManagedService/Customers/helal-d.webp": 882,
	"./assets/images/ManagedService/Customers/helal.webp": 883,
	"./assets/images/ManagedService/Customers/industry.webp": 884,
	"./assets/images/ManagedService/Customers/it.webp": 885,
	"./assets/images/ManagedService/Customers/kale-d.webp": 886,
	"./assets/images/ManagedService/Customers/kale.webp": 887,
	"./assets/images/ManagedService/Customers/mapna-color.png": 888,
	"./assets/images/ManagedService/Customers/mapna-d.webp": 889,
	"./assets/images/ManagedService/Customers/mapna.webp": 890,
	"./assets/images/ManagedService/Customers/software.webp": 891,
	"./assets/images/ManagedService/Direct.svg": 1142,
	"./assets/images/ManagedService/Django.svg": 1143,
	"./assets/images/ManagedService/Elsstic.svg": 1144,
	"./assets/images/ManagedService/Jira.svg": 1145,
	"./assets/images/ManagedService/MariaDB.svg": 1146,
	"./assets/images/ManagedService/Maskgroup.svg": 1084,
	"./assets/images/ManagedService/Microsoft.svg": 1147,
	"./assets/images/ManagedService/MongoDB.svg": 1148,
	"./assets/images/ManagedService/Moodle.svg": 1149,
	"./assets/images/ManagedService/MySQL.svg": 1150,
	"./assets/images/ManagedService/Neo4j.svg": 1151,
	"./assets/images/ManagedService/Opencart.svg": 1152,
	"./assets/images/ManagedService/Plone.svg": 1153,
	"./assets/images/ManagedService/PostgreSQL.svg": 1154,
	"./assets/images/ManagedService/R1.svg": 1072,
	"./assets/images/ManagedService/R2.svg": 1073,
	"./assets/images/ManagedService/R3.svg": 1074,
	"./assets/images/ManagedService/R4.svg": 1075,
	"./assets/images/ManagedService/REDMINE.svg": 1155,
	"./assets/images/ManagedService/Rocket.svg": 1156,
	"./assets/images/ManagedService/Step1-m.svg": 1111,
	"./assets/images/ManagedService/Step1.svg": 1112,
	"./assets/images/ManagedService/Step2-m.svg": 1113,
	"./assets/images/ManagedService/Step2.svg": 1114,
	"./assets/images/ManagedService/Step3.svg": 1115,
	"./assets/images/ManagedService/Wordmark.svg": 1157,
	"./assets/images/ManagedService/agility.svg": 1158,
	"./assets/images/ManagedService/avatar.svg": 1159,
	"./assets/images/ManagedService/avatar2.svg": 1160,
	"./assets/images/ManagedService/avatar3.svg": 1161,
	"./assets/images/ManagedService/avatar4.svg": 1162,
	"./assets/images/ManagedService/avatar5.svg": 1163,
	"./assets/images/ManagedService/cancle.svg": 1116,
	"./assets/images/ManagedService/centralized.svg": 1164,
	"./assets/images/ManagedService/configuration.svg": 1165,
	"./assets/images/ManagedService/devops.svg": 1166,
	"./assets/images/ManagedService/enterprise.svg": 1167,
	"./assets/images/ManagedService/exclusive.svg": 1168,
	"./assets/images/ManagedService/focus.svg": 1169,
	"./assets/images/ManagedService/hardening.svg": 1170,
	"./assets/images/ManagedService/header.svg": 1106,
	"./assets/images/ManagedService/hero.svg": 1093,
	"./assets/images/ManagedService/iRedMail.svg": 1171,
	"./assets/images/ManagedService/joomla.svg": 1172,
	"./assets/images/ManagedService/laravel.svg": 1173,
	"./assets/images/ManagedService/managed_service.png": 1174,
	"./assets/images/ManagedService/managedservices_catalogue.png": 1175,
	"./assets/images/ManagedService/monitor.svg": 1176,
	"./assets/images/ManagedService/monitoring.svg": 1177,
	"./assets/images/ManagedService/osCommerce.svg": 1178,
	"./assets/images/ManagedService/prometheus.svg": 1179,
	"./assets/images/ManagedService/redis.svg": 1180,
	"./assets/images/ManagedService/section-header.svg": 1117,
	"./assets/images/ManagedService/technical.svg": 1181,
	"./assets/images/ManagedService/tick.svg": 1076,
	"./assets/images/ManagedService/tick1.svg": 1118,
	"./assets/images/ManagedService/woocommerce.svg": 1182,
	"./assets/images/Pack1/Back.png": 2116,
	"./assets/images/Pack1/Back1.svg": 2117,
	"./assets/images/Pack1/CloudServer.png": 2118,
	"./assets/images/Pack1/CloudServer.svg": 2119,
	"./assets/images/Pack1/Server1.svg": 2120,
	"./assets/images/Pack1/Server2.svg": 2121,
	"./assets/images/Pack1/Server3.svg": 2122,
	"./assets/images/Pack1/server1.png": 2123,
	"./assets/images/Pack1/server2.png": 2124,
	"./assets/images/Pack1/server3.png": 2125,
	"./assets/images/Pack1/svg/Back1.svg": 2126,
	"./assets/images/Pack1/svg/CloudServer.svg": 2127,
	"./assets/images/Pack1/svg/Server1.svg": 2128,
	"./assets/images/Pack1/svg/Server2.svg": 2129,
	"./assets/images/Pack1/svg/Server3.svg": 2130,
	"./assets/images/Pack2/Back1.svg": 2131,
	"./assets/images/Pack2/Back2.png": 2132,
	"./assets/images/Pack2/Security1.svg": 2133,
	"./assets/images/Pack2/Security2.svg": 2134,
	"./assets/images/Pack2/security1.png": 2135,
	"./assets/images/Pack2/security2.png": 2136,
	"./assets/images/Pack2/svg/Back1.svg": 2137,
	"./assets/images/Pack2/svg/Security1.svg": 2138,
	"./assets/images/Pack2/svg/Security2.svg": 2139,
	"./assets/images/Pack3/Back1.svg": 2140,
	"./assets/images/Pack3/Back2.png": 2141,
	"./assets/images/Pack3/Support.png": 2142,
	"./assets/images/Pack3/Support.svg": 2143,
	"./assets/images/Pack3/svg/Back1.svg": 2144,
	"./assets/images/Pack3/svg/Support.svg": 2145,
	"./assets/images/Pack4/P1.png": 2146,
	"./assets/images/Pack4/P1.svg": 2147,
	"./assets/images/Pack4/P12.png": 2148,
	"./assets/images/Pack4/P2.png": 2149,
	"./assets/images/Pack4/P2.svg": 2150,
	"./assets/images/Pack4/P22.png": 2151,
	"./assets/images/Pack4/P3.png": 2152,
	"./assets/images/Pack4/P3.svg": 2153,
	"./assets/images/Pack5/managed.png": 2154,
	"./assets/images/Pack5/private.png": 2155,
	"./assets/images/Pack5/server.png": 2156,
	"./assets/images/Pack5/svg/managed.svg": 2157,
	"./assets/images/Pack5/svg/private.svg": 2158,
	"./assets/images/Pack5/svg/vpc.svg": 2159,
	"./assets/images/Pack5/svg/vps.svg": 2160,
	"./assets/images/Pack5/vpc.png": 2161,
	"./assets/images/Slider/Back.png": 2162,
	"./assets/images/Slider/Back.svg": 2163,
	"./assets/images/Slider/CloudMain.png": 2164,
	"./assets/images/Slider/CloudMain.svg": 2165,
	"./assets/images/Slider/Group368.png": 2166,
	"./assets/images/Slider/Group368.svg": 2167,
	"./assets/images/Slider/Group383.svg": 2168,
	"./assets/images/Slider/Part1.png": 2169,
	"./assets/images/Slider/Part1.svg": 2170,
	"./assets/images/Slider/Part2.png": 2171,
	"./assets/images/Slider/Part2.svg": 2172,
	"./assets/images/Slider/VPC.png": 2173,
	"./assets/images/Slider/VPC.svg": 2174,
	"./assets/images/Slider/cloud.png": 2175,
	"./assets/images/Slider/cloud.svg": 2176,
	"./assets/images/Slider/managed.png": 2177,
	"./assets/images/Slider/managed.svg": 2178,
	"./assets/images/Technicals/1.png": 2179,
	"./assets/images/Technicals/11.png": 2180,
	"./assets/images/Technicals/12.png": 2181,
	"./assets/images/Technicals/2.png": 2182,
	"./assets/images/Technicals/3.png": 2183,
	"./assets/images/Technicals/4.png": 2184,
	"./assets/images/Technicals/5.png": 2185,
	"./assets/images/Technicals/6.png": 2186,
	"./assets/images/Technicals/7.png": 2187,
	"./assets/images/Technicals/8.png": 2188,
	"./assets/images/Technicals/9.png": 2189,
	"./assets/images/Technicals/Technicals10.png": 2190,
	"./assets/images/VPC/1.png": 1002,
	"./assets/images/VPC/10.png": 1003,
	"./assets/images/VPC/11.png": 1004,
	"./assets/images/VPC/2.png": 1005,
	"./assets/images/VPC/3.png": 1006,
	"./assets/images/VPC/4.png": 1007,
	"./assets/images/VPC/5.png": 1008,
	"./assets/images/VPC/6.png": 1009,
	"./assets/images/VPC/7.png": 1010,
	"./assets/images/VPC/Api.svg": 1011,
	"./assets/images/VPC/CloudCanvas.svg": 1012,
	"./assets/images/VPC/Customers/VPC-IT.jpg": 838,
	"./assets/images/VPC/Customers/VPC-banks.jpg": 839,
	"./assets/images/VPC/Customers/VPC-innovation.jpg": 840,
	"./assets/images/VPC/Customers/VPC-insurance.jpg": 841,
	"./assets/images/VPC/Firewall.svg": 1013,
	"./assets/images/VPC/LoadBalancers.svg": 1014,
	"./assets/images/VPC/NetworkTopology.svg": 1015,
	"./assets/images/VPC/Step1-m.svg": 1016,
	"./assets/images/VPC/Step1.svg": 1017,
	"./assets/images/VPC/Step2-m.svg": 892,
	"./assets/images/VPC/Step2.svg": 893,
	"./assets/images/VPC/Step3.svg": 894,
	"./assets/images/VPC/VPC-Main.svg": 1018,
	"./assets/images/VPC/VPC_Info.svg": 1019,
	"./assets/images/VPC/VS.svg": 700,
	"./assets/images/VPC/VirtualMachins.svg": 1020,
	"./assets/images/VPC/Volumes.svg": 1021,
	"./assets/images/VPC/backup.svg": 1022,
	"./assets/images/VPC/blancing.svg": 1023,
	"./assets/images/VPC/cancle.svg": 702,
	"./assets/images/VPC/cloud-security.svg": 1024,
	"./assets/images/VPC/cloudstorage.svg": 819,
	"./assets/images/VPC/cover-video.jpg": 1025,
	"./assets/images/VPC/dashboard.svg": 1026,
	"./assets/images/VPC/datacenter.svg": 820,
	"./assets/images/VPC/firewall.png": 1027,
	"./assets/images/VPC/freeSupport.svg": 1028,
	"./assets/images/VPC/header.svg": 895,
	"./assets/images/VPC/hq.svg": 1029,
	"./assets/images/VPC/image.svg": 1030,
	"./assets/images/VPC/improve.svg": 1031,
	"./assets/images/VPC/infrustructure.svg": 1032,
	"./assets/images/VPC/ip.png": 1033,
	"./assets/images/VPC/network.png": 1034,
	"./assets/images/VPC/openstack.svg": 1035,
	"./assets/images/VPC/platform.png": 1036,
	"./assets/images/VPC/sazman.svg": 1037,
	"./assets/images/VPC/sdn.svg": 1038,
	"./assets/images/VPC/section-header.svg": 862,
	"./assets/images/VPC/security.svg": 1039,
	"./assets/images/VPC/service-mgs.svg": 1040,
	"./assets/images/VPC/signup.svg": 1041,
	"./assets/images/VPC/sla.svg": 1042,
	"./assets/images/VPC/snapshot.svg": 1043,
	"./assets/images/VPC/store.svg": 1044,
	"./assets/images/VPC/support.svg": 1045,
	"./assets/images/VPC/tick.svg": 701,
	"./assets/images/VPC/video.png": 1046,
	"./assets/images/VPC/vpc-patform.png": 1047,
	"./assets/images/VPC/vpc1.png": 1048,
	"./assets/images/VPC/vpc10.png": 1049,
	"./assets/images/VPC/vpc100.png": 1050,
	"./assets/images/VPC/vpc11.png": 1051,
	"./assets/images/VPC/vpc12.png": 1052,
	"./assets/images/VPC/vpc13.png": 1053,
	"./assets/images/VPC/vpc15.png": 1054,
	"./assets/images/VPC/vpc17.png": 1055,
	"./assets/images/VPC/vpc18.png": 1056,
	"./assets/images/VPC/vpc19.png": 1057,
	"./assets/images/VPC/vpc2.png": 1058,
	"./assets/images/VPC/vpc3.png": 1059,
	"./assets/images/VPC/vpc4.png": 1060,
	"./assets/images/VPC/vpc5.png": 1061,
	"./assets/images/VPC/vpc_platform.png": 1062,
	"./assets/images/VPS/1minute.svg": 713,
	"./assets/images/VPS/24.svg": 714,
	"./assets/images/VPS/AlmaLinux.svg": 715,
	"./assets/images/VPS/Customers/VPS-foods.jpg": 690,
	"./assets/images/VPS/Customers/VPS-khandevane.jpg": 691,
	"./assets/images/VPS/Customers/VPS-manufacturing-firms.jpg": 692,
	"./assets/images/VPS/Customers/VPS-sunich.jpg": 693,
	"./assets/images/VPS/Feature-3.svg": 716,
	"./assets/images/VPS/Feature-4.svg": 717,
	"./assets/images/VPS/Feature-5.svg": 718,
	"./assets/images/VPS/Feature-8.svg": 719,
	"./assets/images/VPS/Fedora.svg": 720,
	"./assets/images/VPS/Google.svg": 721,
	"./assets/images/VPS/HA.svg": 722,
	"./assets/images/VPS/Isolation.svg": 723,
	"./assets/images/VPS/P1.png": 724,
	"./assets/images/VPS/P2.png": 725,
	"./assets/images/VPS/P3.png": 726,
	"./assets/images/VPS/P4.png": 727,
	"./assets/images/VPS/P5.png": 728,
	"./assets/images/VPS/PfSense.svg": 729,
	"./assets/images/VPS/Rocky_Linux.svg": 730,
	"./assets/images/VPS/Step1-m.svg": 731,
	"./assets/images/VPS/Step1.svg": 732,
	"./assets/images/VPS/Step2-m.svg": 733,
	"./assets/images/VPS/Step2.svg": 734,
	"./assets/images/VPS/Step3.svg": 735,
	"./assets/images/VPS/Successful-Google-Cloud-Migration-1440x564_c 1.svg": 736,
	"./assets/images/VPS/VPS_Info_.svg": 737,
	"./assets/images/VPS/ads1.svg": 738,
	"./assets/images/VPS/ads2.svg": 739,
	"./assets/images/VPS/apache.svg": 740,
	"./assets/images/VPS/architect.svg": 741,
	"./assets/images/VPS/backup.svg": 742,
	"./assets/images/VPS/calc.png": 743,
	"./assets/images/VPS/centos.svg": 744,
	"./assets/images/VPS/chooseOs.svg": 745,
	"./assets/images/VPS/common-types.svg": 746,
	"./assets/images/VPS/console.svg": 747,
	"./assets/images/VPS/container.svg": 748,
	"./assets/images/VPS/dashboard.svg": 749,
	"./assets/images/VPS/ddos-c.svg": 750,
	"./assets/images/VPS/ddos-d.svg": 751,
	"./assets/images/VPS/ddos.svg": 752,
	"./assets/images/VPS/debian.svg": 753,
	"./assets/images/VPS/disaster.svg": 754,
	"./assets/images/VPS/docker.svg": 755,
	"./assets/images/VPS/everything.svg": 756,
	"./assets/images/VPS/externalServer.svg": 757,
	"./assets/images/VPS/firewall-new.svg": 758,
	"./assets/images/VPS/firewall.png": 759,
	"./assets/images/VPS/freeSupport.svg": 760,
	"./assets/images/VPS/global.svg": 761,
	"./assets/images/VPS/hq.svg": 762,
	"./assets/images/VPS/iaas_catalogue.png": 763,
	"./assets/images/VPS/ico.png": 764,
	"./assets/images/VPS/image1.svg": 765,
	"./assets/images/VPS/increase.svg": 766,
	"./assets/images/VPS/infrustructure.svg": 767,
	"./assets/images/VPS/ip.png": 768,
	"./assets/images/VPS/iranServer.svg": 769,
	"./assets/images/VPS/list-vps.svg": 770,
	"./assets/images/VPS/mikrotik.svg": 771,
	"./assets/images/VPS/mysql.svg": 772,
	"./assets/images/VPS/nStep1-m.svg": 710,
	"./assets/images/VPS/nStep1.svg": 711,
	"./assets/images/VPS/nginx.svg": 773,
	"./assets/images/VPS/nodejs.svg": 774,
	"./assets/images/VPS/not-found-mobile.svg": 775,
	"./assets/images/VPS/not-found.svg": 776,
	"./assets/images/VPS/panel.svg": 777,
	"./assets/images/VPS/pattern.png": 778,
	"./assets/images/VPS/plans.svg": 779,
	"./assets/images/VPS/plans/Maple.svg": 677,
	"./assets/images/VPS/plans/Willow.svg": 678,
	"./assets/images/VPS/plans/beech.svg": 679,
	"./assets/images/VPS/plans/cedar.svg": 680,
	"./assets/images/VPS/plans/pine.svg": 681,
	"./assets/images/VPS/plans/poplar.svg": 682,
	"./assets/images/VPS/platform.png": 780,
	"./assets/images/VPS/platform2.png": 781,
	"./assets/images/VPS/python.svg": 782,
	"./assets/images/VPS/resource.svg": 783,
	"./assets/images/VPS/service-mgs.svg": 784,
	"./assets/images/VPS/service-vpc.svg": 704,
	"./assets/images/VPS/service-vps.svg": 705,
	"./assets/images/VPS/service.svg": 785,
	"./assets/images/VPS/siem.svg": 786,
	"./assets/images/VPS/sla.svg": 787,
	"./assets/images/VPS/startup.svg": 788,
	"./assets/images/VPS/support.svg": 789,
	"./assets/images/VPS/test.svg": 790,
	"./assets/images/VPS/top-ways.svg": 791,
	"./assets/images/VPS/traffic-vps.svg": 792,
	"./assets/images/VPS/ubuntu18.svg": 793,
	"./assets/images/VPS/ubuntu22.svg": 794,
	"./assets/images/VPS/uptime.svg": 795,
	"./assets/images/VPS/video.png": 796,
	"./assets/images/VPS/vps-header.svg": 689,
	"./assets/images/VPS/vps-hourly.svg": 706,
	"./assets/images/VPS/vps-platform.png": 797,
	"./assets/images/VPS/vps1.png": 798,
	"./assets/images/VPS/vps10.png": 799,
	"./assets/images/VPS/vps2.png": 800,
	"./assets/images/VPS/vps3.png": 801,
	"./assets/images/VPS/vps4.png": 802,
	"./assets/images/VPS/vps5.png": 803,
	"./assets/images/VPS/vps6.png": 804,
	"./assets/images/VPS/vps7.png": 805,
	"./assets/images/VPS/vps8.png": 806,
	"./assets/images/VPS/vps9.png": 807,
	"./assets/images/VPS/vps_figure.png": 808,
	"./assets/images/VPS/vps_icon.png": 683,
	"./assets/images/VPS/vps_picture2.png": 809,
	"./assets/images/VPS/vpspackage.png": 810,
	"./assets/images/VPS/waf-c.svg": 811,
	"./assets/images/VPS/waf-d.svg": 812,
	"./assets/images/VPS/waf-icon-active.svg": 813,
	"./assets/images/VPS/waf-icon.svg": 814,
	"./assets/images/VPS/waf-vps.svg": 815,
	"./assets/images/VPS/waf.svg": 816,
	"./assets/images/VPS/windows.svg": 817,
	"./assets/images/VPS/wordpress.svg": 818,
	"./assets/images/Xicon.svg": 399,
	"./assets/images/banners/123.svg": 1667,
	"./assets/images/banners/Banner-Traffic-Campaign.png": 1668,
	"./assets/images/banners/Banner.jpg": 1669,
	"./assets/images/banners/Banner2.jpg": 1670,
	"./assets/images/banners/Cloud-Database.webp": 1671,
	"./assets/images/banners/Help.webp": 1672,
	"./assets/images/banners/Network-Banner.webp": 1673,
	"./assets/images/banners/Post-1.webp": 1674,
	"./assets/images/banners/Post-2.webp": 1675,
	"./assets/images/banners/Post-3.webp": 1676,
	"./assets/images/banners/SLA.webp": 1677,
	"./assets/images/banners/VPSvsVDS.webp": 1678,
	"./assets/images/banners/banner6.svg": 1679,
	"./assets/images/banners/nowruz-1403-banner.png": 1680,
	"./assets/images/banners/server-response-time.webp": 1681,
	"./assets/images/banners/vpc-service.svg": 1304,
	"./assets/images/banners/yalda-report.png": 1682,
	"./assets/images/cdn/CDN-Header.svg": 1415,
	"./assets/images/cdn/Feature-1.svg": 1501,
	"./assets/images/cdn/Feature-2.svg": 1502,
	"./assets/images/cdn/Feature-3.svg": 1503,
	"./assets/images/cdn/Feature-4.svg": 1504,
	"./assets/images/cdn/Feature-5.svg": 1505,
	"./assets/images/cdn/Feature-6.svg": 1506,
	"./assets/images/cdn/Feature-7.svg": 1507,
	"./assets/images/cdn/Feature-8.svg": 1508,
	"./assets/images/cdn/IranMap.svg": 1416,
	"./assets/images/cdn/Malwares_Attackers.svg": 1509,
	"./assets/images/cdn/access.svg": 1510,
	"./assets/images/cdn/atactks.svg": 1511,
	"./assets/images/cdn/cms.svg": 1512,
	"./assets/images/cdn/company-c.svg": 1513,
	"./assets/images/cdn/company.svg": 1514,
	"./assets/images/cdn/customer.svg": 1515,
	"./assets/images/cdn/ddos-c.svg": 1516,
	"./assets/images/cdn/ddos-d.svg": 1517,
	"./assets/images/cdn/ddos.svg": 1518,
	"./assets/images/cdn/ddosAtacks.svg": 1519,
	"./assets/images/cdn/domain-c.svg": 1520,
	"./assets/images/cdn/domain-d.svg": 1521,
	"./assets/images/cdn/domain.svg": 1522,
	"./assets/images/cdn/domainss.svg": 1523,
	"./assets/images/cdn/earth.svg": 1417,
	"./assets/images/cdn/geography.svg": 1524,
	"./assets/images/cdn/no.svg": 687,
	"./assets/images/cdn/price.svg": 1525,
	"./assets/images/cdn/report-c.svg": 1526,
	"./assets/images/cdn/report-d.svg": 1527,
	"./assets/images/cdn/report.svg": 1528,
	"./assets/images/cdn/scrubbing.svg": 1418,
	"./assets/images/cdn/seo.svg": 1529,
	"./assets/images/cdn/speed.svg": 1530,
	"./assets/images/cdn/ssl.svg": 1531,
	"./assets/images/cdn/startup-c.svg": 1532,
	"./assets/images/cdn/startup.svg": 1533,
	"./assets/images/cdn/store-c.svg": 1534,
	"./assets/images/cdn/store.svg": 1535,
	"./assets/images/cdn/tick.svg": 1536,
	"./assets/images/cdn/uptime.svg": 1537,
	"./assets/images/cdn/waf-c.svg": 1538,
	"./assets/images/cdn/waf-d.svg": 1539,
	"./assets/images/cdn/waf.svg": 1540,
	"./assets/images/cdn/yes.svg": 688,
	"./assets/images/cdn/zarb.svg": 1541,
	"./assets/images/close.svg": 276,
	"./assets/images/cloudGuard/AutomaticProtection.svg": 1742,
	"./assets/images/cloudGuard/CreateCustomRules.svg": 1743,
	"./assets/images/cloudGuard/DDosSection.svg": 1744,
	"./assets/images/cloudGuard/PermanentAccess.svg": 1745,
	"./assets/images/cloudGuard/ReducingDistance.svg": 1746,
	"./assets/images/cloudGuard/SaveResources.svg": 1747,
	"./assets/images/cloudGuard/WebFirewall.svg": 1748,
	"./assets/images/cloudGuard/approach.svg": 1749,
	"./assets/images/cloudGuard/appsAttacks.svg": 1750,
	"./assets/images/cloudGuard/cdnService.svg": 1751,
	"./assets/images/cloudGuard/cloudGuard.svg": 1752,
	"./assets/images/cloudGuard/cloudguard_catalogue.png": 1753,
	"./assets/images/cloudGuard/company-c.svg": 1754,
	"./assets/images/cloudGuard/company.svg": 1755,
	"./assets/images/cloudGuard/ddos-c.svg": 1756,
	"./assets/images/cloudGuard/ddos-d.svg": 1757,
	"./assets/images/cloudGuard/ddos.svg": 1758,
	"./assets/images/cloudGuard/ddosProtection.svg": 1759,
	"./assets/images/cloudGuard/disasterRecovery.svg": 1760,
	"./assets/images/cloudGuard/firewall.svg": 1761,
	"./assets/images/cloudGuard/firewallSetting-c.svg": 1762,
	"./assets/images/cloudGuard/firewallSetting-d.svg": 1763,
	"./assets/images/cloudGuard/firewallSetting.svg": 1764,
	"./assets/images/cloudGuard/freeDNS.svg": 1765,
	"./assets/images/cloudGuard/iam.svg": 1766,
	"./assets/images/cloudGuard/infiniteDomain.svg": 1767,
	"./assets/images/cloudGuard/ip.svg": 1768,
	"./assets/images/cloudGuard/layer7attacks.svg": 1769,
	"./assets/images/cloudGuard/limit-c.svg": 1770,
	"./assets/images/cloudGuard/limit-d.svg": 1771,
	"./assets/images/cloudGuard/limit.svg": 1772,
	"./assets/images/cloudGuard/limitedAccess.svg": 1773,
	"./assets/images/cloudGuard/massAttacks.svg": 1774,
	"./assets/images/cloudGuard/protection.svg": 1775,
	"./assets/images/cloudGuard/protocolAttacks.svg": 1776,
	"./assets/images/cloudGuard/reduceCost.svg": 1777,
	"./assets/images/cloudGuard/region.svg": 1778,
	"./assets/images/cloudGuard/savings.svg": 1779,
	"./assets/images/cloudGuard/scrubbing.svg": 1780,
	"./assets/images/cloudGuard/security.svg": 1781,
	"./assets/images/cloudGuard/seo.svg": 1782,
	"./assets/images/cloudGuard/siem.svg": 1783,
	"./assets/images/cloudGuard/startup-c.svg": 1784,
	"./assets/images/cloudGuard/startup.svg": 1785,
	"./assets/images/cloudGuard/store-c.svg": 1786,
	"./assets/images/cloudGuard/store.svg": 1787,
	"./assets/images/cloudGuard/uptime.svg": 1788,
	"./assets/images/cloudGuard/url.svg": 1789,
	"./assets/images/cloudGuard/userInfo.svg": 1790,
	"./assets/images/cloudGuard/waf-c.svg": 1791,
	"./assets/images/cloudGuard/waf-d.svg": 1792,
	"./assets/images/cloudGuard/waf.svg": 1793,
	"./assets/images/colocation/architect.svg": 1918,
	"./assets/images/colocation/firewall-new.svg": 1919,
	"./assets/images/colocation/resource.svg": 1920,
	"./assets/images/colocation/uptime.svg": 1921,
	"./assets/images/customer/day_logo(1).png": 2191,
	"./assets/images/customer/day_logo(1).svg": 2192,
	"./assets/images/customer/farrahicarpet-logo.png": 2193,
	"./assets/images/customer/farrahicarpet-logo.svg": 2194,
	"./assets/images/customer/logo-.png": 2195,
	"./assets/images/customer/logo-.svg": 2196,
	"./assets/images/customer/logo-hamrahe-aval.png": 2197,
	"./assets/images/customer/logo-hamrahe-aval.svg": 2198,
	"./assets/images/customer/logo-kermanmotor-w.png": 2199,
	"./assets/images/customer/logo-kermanmotor-w.svg": 2200,
	"./assets/images/customer/snowa_logo.png": 2201,
	"./assets/images/customer/snowa_logo.svg": 2202,
	"./assets/images/customer/uniliver(2) 1.png": 2203,
	"./assets/images/customer/uniliver(2) 1.svg": 2204,
	"./assets/images/customers/10.png": 1934,
	"./assets/images/customers/MobileViewLogo-min.png": 1935,
	"./assets/images/customers/banner/HomePage-IT.webp": 961,
	"./assets/images/customers/banner/HomePage-agencies.webp": 962,
	"./assets/images/customers/banner/HomePage-banks.webp": 963,
	"./assets/images/customers/banner/HomePage-elearning.webp": 964,
	"./assets/images/customers/banner/HomePage-foods.webp": 965,
	"./assets/images/customers/banner/HomePage-industries.webp": 966,
	"./assets/images/customers/banner/HomePage-innovation.webp": 967,
	"./assets/images/customers/banner/HomePage-insurance.webp": 968,
	"./assets/images/customers/banner/HomePage-manufacturing-firms.webp": 969,
	"./assets/images/customers/banner/HomePage-media.webp": 970,
	"./assets/images/customers/banner/HomePage-universities.webp": 971,
	"./assets/images/customers/banner/Khandevane.png": 972,
	"./assets/images/customers/banner/sunich.png": 973,
	"./assets/images/customers/bime-day.png": 1936,
	"./assets/images/customers/eseminar.png": 1937,
	"./assets/images/customers/khandevane.png": 1938,
	"./assets/images/customers/logo/Azad.png": 974,
	"./assets/images/customers/logo/IRISA.png": 975,
	"./assets/images/customers/logo/Mapna.png": 976,
	"./assets/images/customers/logo/Samseir.png": 977,
	"./assets/images/customers/logo/day-insurance-gary.png": 978,
	"./assets/images/customers/logo/day-insurance.png": 979,
	"./assets/images/customers/logo/dey.png": 980,
	"./assets/images/customers/logo/diginext-gray.png": 981,
	"./assets/images/customers/logo/diginext.png": 982,
	"./assets/images/customers/logo/eastcool-gray.png": 983,
	"./assets/images/customers/logo/eastcool-rgb.png": 984,
	"./assets/images/customers/logo/esiminar.png": 985,
	"./assets/images/customers/logo/irisa-gray.png": 986,
	"./assets/images/customers/logo/irisa.png": 987,
	"./assets/images/customers/logo/istcoll.png": 988,
	"./assets/images/customers/logo/khandevane-gray.png": 989,
	"./assets/images/customers/logo/khandevane-rgb.png": 990,
	"./assets/images/customers/logo/khandevaneh.png": 991,
	"./assets/images/customers/logo/pars.png": 992,
	"./assets/images/customers/logo/pegah.png": 993,
	"./assets/images/customers/logo/persis-foods-gray.png": 994,
	"./assets/images/customers/logo/persis-foods-rgb.png": 995,
	"./assets/images/customers/logo/refah.png": 996,
	"./assets/images/customers/logo/shahr-financial-group-gray.png": 997,
	"./assets/images/customers/logo/shahr-financial-group.png": 998,
	"./assets/images/customers/logo/shahr.png": 999,
	"./assets/images/customers/logo/sunich-gray.png": 1000,
	"./assets/images/customers/logo/sunich-rgb.png": 1001,
	"./assets/images/customers/meydon.png": 1939,
	"./assets/images/customers/parskh.png": 1940,
	"./assets/images/customers/parsonline.png": 1941,
	"./assets/images/customers/refah.png": 1942,
	"./assets/images/customers/shahr.png": 1943,
	"./assets/images/customers/t1.png": 1944,
	"./assets/images/ddosProtection/1.svg": 1342,
	"./assets/images/ddosProtection/2.svg": 1343,
	"./assets/images/ddosProtection/3.svg": 1344,
	"./assets/images/ddosProtection/CloudGuard-Service.svg": 1345,
	"./assets/images/ddosProtection/DNS.svg": 1346,
	"./assets/images/ddosProtection/ManagedService-Service.svg": 1347,
	"./assets/images/ddosProtection/VPC-Service.svg": 1348,
	"./assets/images/ddosProtection/VPS-Service.svg": 1349,
	"./assets/images/ddosProtection/ddos-d.svg": 1350,
	"./assets/images/ddosProtection/ddos-image.svg": 1253,
	"./assets/images/ddosProtection/ddos.svg": 1351,
	"./assets/images/ddosProtection/devops.svg": 1352,
	"./assets/images/ddosProtection/exclusive.svg": 1353,
	"./assets/images/ddosProtection/firewall-ability.1bb527e 1.svg": 1354,
	"./assets/images/ddosProtection/firewall-setting.cc1ac98 1.svg": 1355,
	"./assets/images/ddosProtection/focus.svg": 1356,
	"./assets/images/ddosProtection/hardening.svg": 1357,
	"./assets/images/ddosProtection/limitation.cb39432 1.svg": 1358,
	"./assets/images/ddosProtection/monitoring.svg": 1359,
	"./assets/images/ddosProtection/technical.svg": 1360,
	"./assets/images/ddosProtection/traffic-vps.aa00c67 1.svg": 1361,
	"./assets/images/ddosProtection/waf-d.svg": 1362,
	"./assets/images/ddosProtection/waf-icon-active.svg": 1363,
	"./assets/images/ddosProtection/waf-icon.svg": 1364,
	"./assets/images/ddosProtection/waf.svg": 1365,
	"./assets/images/dedicateServer/backup.svg": 1827,
	"./assets/images/dedicateServer/buy.svg": 1828,
	"./assets/images/dedicateServer/customized.svg": 1829,
	"./assets/images/dedicateServer/dedicate-server.svg": 1830,
	"./assets/images/dedicateServer/internal-cloud.svg": 1831,
	"./assets/images/dedicateServer/internal.svg": 1832,
	"./assets/images/dedicateServer/performance.svg": 1833,
	"./assets/images/dedicateServer/resource.svg": 1834,
	"./assets/images/dedicateServer/secure.svg": 1835,
	"./assets/images/dedicateServer/web-hosting.svg": 1836,
	"./assets/images/dedicatedServer/firewall-new.svg": 1813,
	"./assets/images/dedicatedServer/image1.svg": 1814,
	"./assets/images/dedicatedServer/resource.svg": 1815,
	"./assets/images/dedicatedServer/uptime.svg": 1816,
	"./assets/images/dns/DNS-Header.svg": 1555,
	"./assets/images/dns/Feature-1.svg": 1817,
	"./assets/images/dns/Feature-2.svg": 1818,
	"./assets/images/dns/Feature-3.svg": 1819,
	"./assets/images/dns/Feature-4.svg": 1820,
	"./assets/images/dns/anyCast.svg": 1821,
	"./assets/images/dns/dnsPanel.svg": 1822,
	"./assets/images/dns/noLimit.svg": 1823,
	"./assets/images/dns/responseDelay.svg": 1824,
	"./assets/images/dns/unlimitedDomain.svg": 1825,
	"./assets/images/europeVps/24.svg": 1427,
	"./assets/images/europeVps/CloudGuard-Service.svg": 1428,
	"./assets/images/europeVps/DNS.svg": 1429,
	"./assets/images/europeVps/ManagedService-Service.svg": 1430,
	"./assets/images/europeVps/VPC-Service.svg": 1431,
	"./assets/images/europeVps/backup.svg": 1432,
	"./assets/images/europeVps/chooseOs.svg": 1433,
	"./assets/images/europeVps/console.svg": 1434,
	"./assets/images/europeVps/dashboard.svg": 1435,
	"./assets/images/europeVps/ddos-d.svg": 1436,
	"./assets/images/europeVps/ddos.svg": 1437,
	"./assets/images/europeVps/disaster.svg": 1438,
	"./assets/images/europeVps/freeSupport.svg": 1439,
	"./assets/images/europeVps/global.svg": 1440,
	"./assets/images/europeVps/hq.svg": 1441,
	"./assets/images/europeVps/infrustructure.svg": 1442,
	"./assets/images/europeVps/list-vps.f735948 1.svg": 1443,
	"./assets/images/europeVps/service.svg": 1444,
	"./assets/images/europeVps/startup.svg": 1445,
	"./assets/images/europeVps/traffic-vps.aa00c67 1.svg": 1446,
	"./assets/images/europeVps/waf-d.svg": 1447,
	"./assets/images/europeVps/waf-icon-active copy.svg": 1448,
	"./assets/images/europeVps/waf-icon-active.svg": 1449,
	"./assets/images/europeVps/waf-icon.svg": 1450,
	"./assets/images/europeVps/waf-vps.fcecd73 1.svg": 1451,
	"./assets/images/europeVps/waf.svg": 1452,
	"./assets/images/footer.png": 408,
	"./assets/images/footer/anjoman.svg": 409,
	"./assets/images/footer/daneshbonyan.svg": 410,
	"./assets/images/footer/enamad.svg": 411,
	"./assets/images/footer/fab.svg": 412,
	"./assets/images/footer/instagram.svg": 413,
	"./assets/images/footer/linkedin.svg": 414,
	"./assets/images/footer/location.svg": 415,
	"./assets/images/footer/nezamsenfi.svg": 416,
	"./assets/images/footer/occc.svg": 417,
	"./assets/images/footer/phone.svg": 418,
	"./assets/images/footer/riasatjomhoori.svg": 419,
	"./assets/images/footer/telegram.svg": 420,
	"./assets/images/footer/twitter.svg": 421,
	"./assets/images/footer/youtube.svg": 422,
	"./assets/images/form.svg": 400,
	"./assets/images/header/vpc-icon.webp": 1584,
	"./assets/images/home/Content distribution-c.svg": 1375,
	"./assets/images/home/Managedservices-c.svg": 1376,
	"./assets/images/home/Platform-c.svg": 1377,
	"./assets/images/home/Server-c.svg": 1378,
	"./assets/images/home/TrafficCampaign.svg": 1379,
	"./assets/images/home/contentdistribution.svg": 1380,
	"./assets/images/home/contentdistribution_d.svg": 1381,
	"./assets/images/home/data center-c.svg": 1382,
	"./assets/images/home/general_catalogue.png": 1383,
	"./assets/images/home/live.svg": 1384,
	"./assets/images/home/manageServices.svg": 1385,
	"./assets/images/home/manageServices_d.svg": 1386,
	"./assets/images/home/nowruz-1403-logo.svg": 1387,
	"./assets/images/home/nowruz.png": 1388,
	"./assets/images/home/paas.svg": 1389,
	"./assets/images/home/paas_d.svg": 1390,
	"./assets/images/home/security-c.svg": 1391,
	"./assets/images/home/security.svg": 1392,
	"./assets/images/home/security_d.svg": 1393,
	"./assets/images/home/shop.svg": 1394,
	"./assets/images/home/vpc.svg": 1395,
	"./assets/images/home/vpc_d.svg": 1396,
	"./assets/images/home/vps.svg": 1397,
	"./assets/images/home/vps_d.svg": 1398,
	"./assets/images/home/yalda-m.svg": 1399,
	"./assets/images/home/yalda.png": 1400,
	"./assets/images/hourlyVps/1minute.svg": 1453,
	"./assets/images/hourlyVps/24.svg": 1454,
	"./assets/images/hourlyVps/CloudGuard-Service.svg": 1455,
	"./assets/images/hourlyVps/DNS.svg": 1456,
	"./assets/images/hourlyVps/ManagedService-Service.svg": 1457,
	"./assets/images/hourlyVps/VPC-Service.svg": 1458,
	"./assets/images/hourlyVps/chooseOs.svg": 1459,
	"./assets/images/hourlyVps/console.svg": 1460,
	"./assets/images/hourlyVps/dashboard.svg": 1461,
	"./assets/images/hourlyVps/ddos-d.svg": 1462,
	"./assets/images/hourlyVps/ddos.svg": 1463,
	"./assets/images/hourlyVps/disaster.svg": 1464,
	"./assets/images/hourlyVps/firewall-new.svg": 1465,
	"./assets/images/hourlyVps/freeSupport.svg": 1466,
	"./assets/images/hourlyVps/global.svg": 1467,
	"./assets/images/hourlyVps/hq.svg": 1468,
	"./assets/images/hourlyVps/increase.svg": 1469,
	"./assets/images/hourlyVps/infrustructure.svg": 1470,
	"./assets/images/hourlyVps/list-vps.f735948 1.svg": 1471,
	"./assets/images/hourlyVps/sla.svg": 1472,
	"./assets/images/hourlyVps/startup.svg": 1473,
	"./assets/images/hourlyVps/support.svg": 1474,
	"./assets/images/hourlyVps/test.svg": 1475,
	"./assets/images/hourlyVps/traffic-vps.aa00c67 1.svg": 1476,
	"./assets/images/hourlyVps/uptime.svg": 1477,
	"./assets/images/hourlyVps/virtualOrganization.svg": 1478,
	"./assets/images/hourlyVps/waf-d.svg": 1479,
	"./assets/images/hourlyVps/waf-icon-active.svg": 1480,
	"./assets/images/hourlyVps/waf-icon.svg": 1481,
	"./assets/images/hourlyVps/waf-vps.fcecd73 1.svg": 1482,
	"./assets/images/hourlyVps/waf.svg": 1483,
	"./assets/images/icons/1.png": 896,
	"./assets/images/icons/2.png": 897,
	"./assets/images/icons/3.png": 898,
	"./assets/images/icons/4.png": 899,
	"./assets/images/icons/5.png": 900,
	"./assets/images/icons/5.svg": 901,
	"./assets/images/icons/6.png": 902,
	"./assets/images/icons/7.png": 903,
	"./assets/images/icons/CloudGuard-Service.svg": 904,
	"./assets/images/icons/DNS.svg": 905,
	"./assets/images/icons/GoDown.png": 906,
	"./assets/images/icons/GoDown.svg": 907,
	"./assets/images/icons/GoTop.png": 908,
	"./assets/images/icons/GoTop.svg": 909,
	"./assets/images/icons/Group 420.png": 910,
	"./assets/images/icons/Group 420.svg": 911,
	"./assets/images/icons/Group 78.png": 912,
	"./assets/images/icons/Group 78.svg": 913,
	"./assets/images/icons/Group.png": 914,
	"./assets/images/icons/Insta.png": 915,
	"./assets/images/icons/ManagedService-Service.svg": 916,
	"./assets/images/icons/VPC-Service.svg": 917,
	"./assets/images/icons/VPS-Service.svg": 918,
	"./assets/images/icons/anjoman_s.png": 919,
	"./assets/images/icons/anjoman_s.svg": 920,
	"./assets/images/icons/bar.svg": 921,
	"./assets/images/icons/cloud-dns.svg": 922,
	"./assets/images/icons/contact.png": 923,
	"./assets/images/icons/contact.svg": 867,
	"./assets/images/icons/daneshbonyan.png": 924,
	"./assets/images/icons/daneshbonyan.svg": 925,
	"./assets/images/icons/ddos.svg": 926,
	"./assets/images/icons/discount.png": 927,
	"./assets/images/icons/discount.svg": 928,
	"./assets/images/icons/enamad-logo.png": 929,
	"./assets/images/icons/enamad-logo.svg": 930,
	"./assets/images/icons/facebook.png": 931,
	"./assets/images/icons/facebook.svg": 932,
	"./assets/images/icons/github.png": 933,
	"./assets/images/icons/github.svg": 934,
	"./assets/images/icons/insta.svg": 935,
	"./assets/images/icons/instagram.png": 936,
	"./assets/images/icons/instagram.svg": 937,
	"./assets/images/icons/linked.svg": 938,
	"./assets/images/icons/linkedin.png": 939,
	"./assets/images/icons/linkedin.svg": 940,
	"./assets/images/icons/new/xaas-instagram.png": 941,
	"./assets/images/icons/new/xaas-linkedin.png": 942,
	"./assets/images/icons/new/xaas-telegram.png": 943,
	"./assets/images/icons/new/xaas-twitter.png": 944,
	"./assets/images/icons/new/xaas-youtube.png": 945,
	"./assets/images/icons/nezam-senfi.png": 946,
	"./assets/images/icons/nezam-senfi.svg": 947,
	"./assets/images/icons/quote.png": 694,
	"./assets/images/icons/showMore.svg": 836,
	"./assets/images/icons/tweet.svg": 948,
	"./assets/images/icons/tweter.png": 949,
	"./assets/images/icons/twitter.png": 950,
	"./assets/images/icons/twitter.svg": 951,
	"./assets/images/icons/vps_icon2.png": 952,
	"./assets/images/icons/xaas-fab.png": 953,
	"./assets/images/icons/xaas-fab.svg": 954,
	"./assets/images/icons/xaas-occc.png": 955,
	"./assets/images/icons/xaas-occc.svg": 956,
	"./assets/images/icons/xaas-riasat-jomhoori.png": 957,
	"./assets/images/icons/xaas-riasat-jomhoori.svg": 958,
	"./assets/images/img1.png": 1837,
	"./assets/images/img2.png": 2205,
	"./assets/images/isolatedCloud/CloudGuard-Service.svg": 1278,
	"./assets/images/isolatedCloud/Feature-1.svg": 1279,
	"./assets/images/isolatedCloud/Feature-2.svg": 1280,
	"./assets/images/isolatedCloud/Feature-3.svg": 1281,
	"./assets/images/isolatedCloud/Feature-4.svg": 1282,
	"./assets/images/isolatedCloud/Feature-5.svg": 1283,
	"./assets/images/isolatedCloud/Feature-6.svg": 1284,
	"./assets/images/isolatedCloud/Feature-7.svg": 1285,
	"./assets/images/isolatedCloud/Feature-8.svg": 1286,
	"./assets/images/isolatedCloud/ManagedService-Service.svg": 1287,
	"./assets/images/isolatedCloud/VPC-Service.svg": 1288,
	"./assets/images/isolatedCloud/VPS-Service.svg": 1289,
	"./assets/images/isolatedCloud/advancedSecurity.svg": 1290,
	"./assets/images/isolatedCloud/backup.svg": 1291,
	"./assets/images/isolatedCloud/disaster.svg": 1292,
	"./assets/images/isolatedCloud/easyBuy.svg": 1293,
	"./assets/images/isolatedCloud/easyUse.svg": 1294,
	"./assets/images/isolatedCloud/hunezarat.svg": 1190,
	"./assets/images/isolatedCloud/liveMigration.svg": 1295,
	"./assets/images/isolatedCloud/reliability.svg": 1296,
	"./assets/images/isolatedCloud/service.svg": 1297,
	"./assets/images/isolatedCloud/startup.svg": 1298,
	"./assets/images/isolatedCloud/test.svg": 1299,
	"./assets/images/isolatedCloud/virtualOrganization.svg": 1300,
	"./assets/images/landing/1045479.svg": 2206,
	"./assets/images/landing/2906274.svg": 2207,
	"./assets/images/landing/860238.svg": 2208,
	"./assets/images/landing/860239.svg": 2209,
	"./assets/images/landing/Group 12.svg": 2210,
	"./assets/images/landing/Group 13.svg": 2211,
	"./assets/images/landing/Group 14.svg": 2212,
	"./assets/images/landing/Group 15.svg": 2213,
	"./assets/images/landing/Group 16.webp": 2214,
	"./assets/images/landing/Group 17.svg": 2215,
	"./assets/images/landing/Group.svg": 1945,
	"./assets/images/landing/Xaas.svg": 2216,
	"./assets/images/landing/abr.svg": 2217,
	"./assets/images/landing/avatar.svg": 1946,
	"./assets/images/landing/background.png": 2218,
	"./assets/images/landing/button.svg": 1932,
	"./assets/images/landing/chamedoon.png": 1933,
	"./assets/images/landing/cloud.svg": 2219,
	"./assets/images/landing/data-analysis.svg": 2220,
	"./assets/images/landing/landing.jpg": 1947,
	"./assets/images/landing/project-analysis.svg": 2221,
	"./assets/images/landing/shield.svg": 1948,
	"./assets/images/landing/small-screen-arrow.svg": 2222,
	"./assets/images/landing/web-security.svg": 2223,
	"./assets/images/linuxVps/1minute.svg": 1557,
	"./assets/images/linuxVps/24.svg": 1558,
	"./assets/images/linuxVps/CloudGuard-Service.svg": 1559,
	"./assets/images/linuxVps/DNS.svg": 1560,
	"./assets/images/linuxVps/ManagedService-Service.svg": 1561,
	"./assets/images/linuxVps/VPC-Service.svg": 1562,
	"./assets/images/linuxVps/chooseOs.svg": 1563,
	"./assets/images/linuxVps/console.svg": 1564,
	"./assets/images/linuxVps/dashboard.svg": 1565,
	"./assets/images/linuxVps/ddos-d.svg": 1566,
	"./assets/images/linuxVps/ddos.svg": 1567,
	"./assets/images/linuxVps/firewall-new.svg": 1568,
	"./assets/images/linuxVps/freeSupport.svg": 1569,
	"./assets/images/linuxVps/global.svg": 1570,
	"./assets/images/linuxVps/hq.svg": 1571,
	"./assets/images/linuxVps/increase.svg": 1572,
	"./assets/images/linuxVps/infrustructure.svg": 1573,
	"./assets/images/linuxVps/list-vps.f735948 1.svg": 1574,
	"./assets/images/linuxVps/sla.svg": 1575,
	"./assets/images/linuxVps/support.svg": 1576,
	"./assets/images/linuxVps/traffic-vps.aa00c67 1.svg": 1577,
	"./assets/images/linuxVps/uptime.svg": 1578,
	"./assets/images/linuxVps/waf-d.svg": 1579,
	"./assets/images/linuxVps/waf-icon-active.svg": 1580,
	"./assets/images/linuxVps/waf-icon.svg": 1581,
	"./assets/images/linuxVps/waf-vps.fcecd73 1.svg": 1582,
	"./assets/images/linuxVps/waf.svg": 1583,
	"./assets/images/logo-w.svg": 2224,
	"./assets/images/logo.svg": 1585,
	"./assets/images/menu-icons/addons.svg": 424,
	"./assets/images/menu-icons/blog.svg": 425,
	"./assets/images/menu-icons/calc.svg": 426,
	"./assets/images/menu-icons/cdn.svg": 427,
	"./assets/images/menu-icons/cdn24.svg": 428,
	"./assets/images/menu-icons/cloud-network.svg": 429,
	"./assets/images/menu-icons/combination-cloud.svg": 430,
	"./assets/images/menu-icons/company-size.svg": 431,
	"./assets/images/menu-icons/coprate.svg": 432,
	"./assets/images/menu-icons/ddos.svg": 433,
	"./assets/images/menu-icons/digital-tahavol.svg": 434,
	"./assets/images/menu-icons/faq.svg": 435,
	"./assets/images/menu-icons/free.svg": 436,
	"./assets/images/menu-icons/how-to-start.svg": 437,
	"./assets/images/menu-icons/in-xaas.svg": 438,
	"./assets/images/menu-icons/industry.svg": 439,
	"./assets/images/menu-icons/infra.svg": 440,
	"./assets/images/menu-icons/left15.svg": 441,
	"./assets/images/menu-icons/left7.svg": 442,
	"./assets/images/menu-icons/main3.svg": 443,
	"./assets/images/menu-icons/manage.svg": 444,
	"./assets/images/menu-icons/manage24.svg": 445,
	"./assets/images/menu-icons/migrate.svg": 446,
	"./assets/images/menu-icons/organ-docs.svg": 447,
	"./assets/images/menu-icons/organ-security.svg": 448,
	"./assets/images/menu-icons/organ-solutions.svg": 449,
	"./assets/images/menu-icons/organization.svg": 450,
	"./assets/images/menu-icons/paas.svg": 451,
	"./assets/images/menu-icons/prices.svg": 452,
	"./assets/images/menu-icons/private-cloud.svg": 453,
	"./assets/images/menu-icons/security.svg": 454,
	"./assets/images/menu-icons/service-help.svg": 455,
	"./assets/images/menu-icons/sla.svg": 456,
	"./assets/images/menu-icons/special.svg": 457,
	"./assets/images/menu-icons/storage.svg": 458,
	"./assets/images/menu-icons/tech-services-for-organs.svg": 459,
	"./assets/images/menu-icons/vpc.svg": 460,
	"./assets/images/menu-icons/vps.svg": 461,
	"./assets/images/new_customers/HiMart.png": 2225,
	"./assets/images/new_customers/amirkabir.png": 2226,
	"./assets/images/new_customers/azad.png": 2227,
	"./assets/images/new_customers/bankrefah.png": 2228,
	"./assets/images/new_customers/bankshahr.png": 2229,
	"./assets/images/new_customers/barkat.png": 2230,
	"./assets/images/new_customers/bidbarg.png": 2231,
	"./assets/images/new_customers/bime-dey.png": 2232,
	"./assets/images/new_customers/digikala.png": 2233,
	"./assets/images/new_customers/eastcool.png": 2234,
	"./assets/images/new_customers/elmosanat.png": 2235,
	"./assets/images/new_customers/freezone.png": 2236,
	"./assets/images/new_customers/irisaco.png": 2237,
	"./assets/images/new_customers/jameazad.png": 2238,
	"./assets/images/new_customers/javid.png": 2239,
	"./assets/images/new_customers/khandevane.png": 2240,
	"./assets/images/new_customers/madiran.png": 2241,
	"./assets/images/new_customers/mahran.png": 2242,
	"./assets/images/new_customers/mashal.png": 2243,
	"./assets/images/new_customers/meydon.png": 2244,
	"./assets/images/new_customers/mofid.png": 2245,
	"./assets/images/new_customers/netbarg.png": 2246,
	"./assets/images/new_customers/parskhazar.png": 2247,
	"./assets/images/new_customers/parsonline.png": 2248,
	"./assets/images/new_customers/pegah.png": 2249,
	"./assets/images/new_customers/pejoheshgah.png": 2250,
	"./assets/images/new_customers/samseir.png": 2251,
	"./assets/images/new_customers/tanzim.png": 2252,
	"./assets/images/organizationalSolution/24.svg": 1312,
	"./assets/images/organizationalSolution/CDN-Header.svg": 1250,
	"./assets/images/organizationalSolution/CloudGuard-Service.svg": 1313,
	"./assets/images/organizationalSolution/DNS.svg": 1314,
	"./assets/images/organizationalSolution/HA.svg": 1315,
	"./assets/images/organizationalSolution/Isolation.svg": 1316,
	"./assets/images/organizationalSolution/ManagedService-Service.svg": 1317,
	"./assets/images/organizationalSolution/VPC-Main.svg": 1251,
	"./assets/images/organizationalSolution/VPC-Service.svg": 1318,
	"./assets/images/organizationalSolution/architect.svg": 1319,
	"./assets/images/organizationalSolution/backup.svg": 1320,
	"./assets/images/organizationalSolution/blancing.svg": 1321,
	"./assets/images/organizationalSolution/chooseOs.svg": 1322,
	"./assets/images/organizationalSolution/container.svg": 1323,
	"./assets/images/organizationalSolution/dashboard.svg": 1324,
	"./assets/images/organizationalSolution/ddos-image.svg": 1252,
	"./assets/images/organizationalSolution/devops.svg": 1325,
	"./assets/images/organizationalSolution/freeSupport.svg": 1326,
	"./assets/images/organizationalSolution/global.svg": 1327,
	"./assets/images/organizationalSolution/header.svg": 1328,
	"./assets/images/organizationalSolution/improve.svg": 1329,
	"./assets/images/organizationalSolution/increase.svg": 1330,
	"./assets/images/organizationalSolution/kuber.svg": 1331,
	"./assets/images/organizationalSolution/migration.svg": 1332,
	"./assets/images/organizationalSolution/monitoring.svg": 1333,
	"./assets/images/organizationalSolution/openstack.svg": 1334,
	"./assets/images/organizationalSolution/panel.svg": 1335,
	"./assets/images/organizationalSolution/plans.svg": 1336,
	"./assets/images/organizationalSolution/resource.svg": 1337,
	"./assets/images/organizationalSolution/service.svg": 1338,
	"./assets/images/organizationalSolution/sla.svg": 1339,
	"./assets/images/organizationalSolution/snapshot.svg": 1340,
	"./assets/images/organizationalSolution/support.svg": 1341,
	"./assets/images/paas/1.png": 1838,
	"./assets/images/paas/1.svg": 1839,
	"./assets/images/paas/10.svg": 1840,
	"./assets/images/paas/2.png": 1841,
	"./assets/images/paas/2.svg": 1842,
	"./assets/images/paas/3.png": 1843,
	"./assets/images/paas/3.svg": 1844,
	"./assets/images/paas/4.png": 1845,
	"./assets/images/paas/4.svg": 1846,
	"./assets/images/paas/5.svg": 1586,
	"./assets/images/paas/6.svg": 1587,
	"./assets/images/paas/7.svg": 1588,
	"./assets/images/paas/8.svg": 1847,
	"./assets/images/paas/9.svg": 1848,
	"./assets/images/paas/api.svg": 1849,
	"./assets/images/paas/dashboard.svg": 1850,
	"./assets/images/paas/esteghrar.svg": 1851,
	"./assets/images/paas/event.svg": 1852,
	"./assets/images/paas/logo.svg": 1589,
	"./assets/images/paas/monitoring.svg": 1853,
	"./assets/images/paas/scale.svg": 1854,
	"./assets/images/paas/store.svg": 1855,
	"./assets/images/paas/support.svg": 1856,
	"./assets/images/paas/tozie.svg": 1857,
	"./assets/images/pomegrante.svg": 2253,
	"./assets/images/rebranding/catalogue/managed-services-catalogue.webp": 2254,
	"./assets/images/rebranding/catalogue/solutions-catalogue.webp": 1590,
	"./assets/images/rebranding/contact/account.svg": 2255,
	"./assets/images/rebranding/contact/contract.svg": 2256,
	"./assets/images/rebranding/contact/products.svg": 2257,
	"./assets/images/rebranding/contact/support.svg": 2258,
	"./assets/images/rebranding/content/cdn.webp": 1191,
	"./assets/images/rebranding/content/colocation.webp": 1192,
	"./assets/images/rebranding/content/ddos.webp": 1193,
	"./assets/images/rebranding/content/dedicated-server.webp": 1194,
	"./assets/images/rebranding/content/dns.webp": 1195,
	"./assets/images/rebranding/content/firewall.webp": 1196,
	"./assets/images/rebranding/content/graphics-server.webp": 1197,
	"./assets/images/rebranding/content/local-storage.webp": 1198,
	"./assets/images/rebranding/content/object-storage.webp": 1199,
	"./assets/images/rebranding/content/vpc.webp": 1200,
	"./assets/images/rebranding/content/vps.webp": 1201,
	"./assets/images/rebranding/content/waf.webp": 1202,
	"./assets/images/rebranding/customerLogos/1.webp": 1203,
	"./assets/images/rebranding/customerLogos/10.webp": 1204,
	"./assets/images/rebranding/customerLogos/11.webp": 1205,
	"./assets/images/rebranding/customerLogos/12.webp": 1206,
	"./assets/images/rebranding/customerLogos/13.webp": 1207,
	"./assets/images/rebranding/customerLogos/14.webp": 1208,
	"./assets/images/rebranding/customerLogos/15.webp": 1209,
	"./assets/images/rebranding/customerLogos/16.webp": 1210,
	"./assets/images/rebranding/customerLogos/17.webp": 1211,
	"./assets/images/rebranding/customerLogos/18.webp": 1212,
	"./assets/images/rebranding/customerLogos/19.webp": 1213,
	"./assets/images/rebranding/customerLogos/2.webp": 1214,
	"./assets/images/rebranding/customerLogos/20.webp": 1215,
	"./assets/images/rebranding/customerLogos/21.webp": 1216,
	"./assets/images/rebranding/customerLogos/22.webp": 1217,
	"./assets/images/rebranding/customerLogos/23.webp": 1218,
	"./assets/images/rebranding/customerLogos/24.webp": 1219,
	"./assets/images/rebranding/customerLogos/25.webp": 1220,
	"./assets/images/rebranding/customerLogos/26.webp": 1221,
	"./assets/images/rebranding/customerLogos/27.webp": 1222,
	"./assets/images/rebranding/customerLogos/28.webp": 1223,
	"./assets/images/rebranding/customerLogos/29.webp": 1224,
	"./assets/images/rebranding/customerLogos/3.webp": 1225,
	"./assets/images/rebranding/customerLogos/30.webp": 1226,
	"./assets/images/rebranding/customerLogos/31.webp": 1227,
	"./assets/images/rebranding/customerLogos/32.webp": 1228,
	"./assets/images/rebranding/customerLogos/33.webp": 1229,
	"./assets/images/rebranding/customerLogos/34.webp": 1230,
	"./assets/images/rebranding/customerLogos/35.webp": 1231,
	"./assets/images/rebranding/customerLogos/36.webp": 1232,
	"./assets/images/rebranding/customerLogos/37.webp": 1233,
	"./assets/images/rebranding/customerLogos/38.webp": 1234,
	"./assets/images/rebranding/customerLogos/39.webp": 1235,
	"./assets/images/rebranding/customerLogos/4.webp": 1236,
	"./assets/images/rebranding/customerLogos/40.webp": 1237,
	"./assets/images/rebranding/customerLogos/5.webp": 1238,
	"./assets/images/rebranding/customerLogos/6.webp": 1239,
	"./assets/images/rebranding/customerLogos/7.webp": 1240,
	"./assets/images/rebranding/customerLogos/8.webp": 1241,
	"./assets/images/rebranding/customerLogos/9.webp": 1242,
	"./assets/images/rebranding/customers/content/e-seminar.webp": 1367,
	"./assets/images/rebranding/customers/content/helal-ahmar.webp": 1368,
	"./assets/images/rebranding/customers/content/ikco.webp": 1369,
	"./assets/images/rebranding/customers/content/mapna.webp": 1370,
	"./assets/images/rebranding/customers/content/milli-1.webp": 1371,
	"./assets/images/rebranding/customers/content/milli.webp": 1372,
	"./assets/images/rebranding/customers/content/solico.webp": 1373,
	"./assets/images/rebranding/customers/e-seminar.png": 1591,
	"./assets/images/rebranding/customers/helal-ahmar.png": 1592,
	"./assets/images/rebranding/customers/ikco.png": 1593,
	"./assets/images/rebranding/customers/mapna.png": 1594,
	"./assets/images/rebranding/customers/milli-gold.png": 1595,
	"./assets/images/rebranding/customers/solico.png": 1596,
	"./assets/images/rebranding/heroBackground.webp": 1597,
	"./assets/images/rebranding/logo/logo-blue.svg": 2259,
	"./assets/images/rebranding/logo/logo-dark.svg": 2260,
	"./assets/images/rebranding/logo/logo-en-botton-blue.svg": 2261,
	"./assets/images/rebranding/logo/logo-en-botton-dark.svg": 2262,
	"./assets/images/rebranding/logo/logo-en-botton-gradiant.svg": 2263,
	"./assets/images/rebranding/logo/logo-en-botton-white.svg": 2264,
	"./assets/images/rebranding/logo/logo-en-left-blue.svg": 2265,
	"./assets/images/rebranding/logo/logo-en-left-dark.svg": 2266,
	"./assets/images/rebranding/logo/logo-en-left-gradiant.svg": 2267,
	"./assets/images/rebranding/logo/logo-en-left-white.svg": 407,
	"./assets/images/rebranding/logo/logo-fa-botton-blue.svg": 2268,
	"./assets/images/rebranding/logo/logo-fa-botton-dark.svg": 2269,
	"./assets/images/rebranding/logo/logo-fa-botton-gradiant.svg": 2270,
	"./assets/images/rebranding/logo/logo-fa-botton-white.svg": 2271,
	"./assets/images/rebranding/logo/logo-fa-left-blue.svg": 423,
	"./assets/images/rebranding/logo/logo-fa-left-dark.svg": 2272,
	"./assets/images/rebranding/logo/logo-fa-left-gradiant.svg": 2273,
	"./assets/images/rebranding/logo/logo-fa-left-white.svg": 2274,
	"./assets/images/rebranding/logo/logo-gradiant.svg": 2275,
	"./assets/images/rebranding/logo/logo-white.svg": 2276,
	"./assets/images/rebranding/pages/1.b820ea4 1.svg": 825,
	"./assets/images/rebranding/pages/3.32dda95 1.svg": 826,
	"./assets/images/rebranding/pages/Api.701b548 2.svg": 842,
	"./assets/images/rebranding/pages/CloudCanvas.82fd9ce 1.svg": 843,
	"./assets/images/rebranding/pages/Firewall.398439d 1.svg": 844,
	"./assets/images/rebranding/pages/LoadBalancers.4b40924 1.svg": 845,
	"./assets/images/rebranding/pages/Logo.svg": 834,
	"./assets/images/rebranding/pages/NetworkTopology.3e287eb 1.svg": 846,
	"./assets/images/rebranding/pages/Step1.73148bc.svg": 827,
	"./assets/images/rebranding/pages/VPC-Main.b1c5b7f.svg": 824,
	"./assets/images/rebranding/pages/VirtualMachins.217b5d7 1.svg": 847,
	"./assets/images/rebranding/pages/Volumes.d769ca6 1.svg": 848,
	"./assets/images/rebranding/pages/WAE.svg": 849,
	"./assets/images/rebranding/pages/abalon-logo.svg": 835,
	"./assets/images/rebranding/pages/cloud-platforms.png": 828,
	"./assets/images/rebranding/pages/ddos-c.7eebc2f 1.svg": 850,
	"./assets/images/rebranding/pages/dnsPanel.af7f507 1.svg": 829,
	"./assets/images/rebranding/pages/domain-c.409b389.svg": 851,
	"./assets/images/rebranding/pages/firewall-ability.1bb527e 1.svg": 852,
	"./assets/images/rebranding/pages/firewall-ability.1bb527e 2.svg": 853,
	"./assets/images/rebranding/pages/firewall-setting.cc1ac98 1.svg": 854,
	"./assets/images/rebranding/pages/header.1b96d2f 1.svg": 833,
	"./assets/images/rebranding/pages/kuber.png": 830,
	"./assets/images/rebranding/pages/limitation.cb39432 1.svg": 855,
	"./assets/images/rebranding/pages/list-vps.f735948 1.svg": 856,
	"./assets/images/rebranding/pages/map.9a4bec5 1.svg": 831,
	"./assets/images/rebranding/pages/not-found-mobile.7b6fab4.svg": 696,
	"./assets/images/rebranding/pages/not-found.4ba4a5c 1.svg": 695,
	"./assets/images/rebranding/pages/report-c.11b26e7 1.svg": 857,
	"./assets/images/rebranding/pages/traffic-vps.aa00c67 1.svg": 858,
	"./assets/images/rebranding/pages/waf-c.6f5be55 1.svg": 859,
	"./assets/images/rebranding/pages/waf-vps.fcecd73 1.svg": 860,
	"./assets/images/rebranding/products/card-background-1.webp": 1598,
	"./assets/images/rebranding/products/card-background-2.webp": 1599,
	"./assets/images/rebranding/products/card-background.webp": 1110,
	"./assets/images/rebranding/products2/1.svg": 1600,
	"./assets/images/rebranding/products2/2.svg": 1601,
	"./assets/images/rebranding/products2/3.svg": 1602,
	"./assets/images/rebranding/products2/4.svg": 1603,
	"./assets/images/rebranding/products2/5.svg": 1604,
	"./assets/images/rebranding/products2/6.svg": 1605,
	"./assets/images/rebranding/products2/backup/1.svg": 1606,
	"./assets/images/rebranding/products2/backup/2.svg": 1607,
	"./assets/images/rebranding/products2/backup/3.svg": 1608,
	"./assets/images/rebranding/products2/backup/4.svg": 1609,
	"./assets/images/rebranding/products2/backup/5.svg": 1610,
	"./assets/images/rebranding/products2/backup/6.svg": 1611,
	"./assets/images/rebranding/products2/backup/primary.svg": 1612,
	"./assets/images/rebranding/products2/devops/1.svg": 1613,
	"./assets/images/rebranding/products2/devops/2.svg": 1614,
	"./assets/images/rebranding/products2/devops/3.svg": 1615,
	"./assets/images/rebranding/products2/devops/4.svg": 1616,
	"./assets/images/rebranding/products2/devops/5.svg": 1617,
	"./assets/images/rebranding/products2/devops/6.svg": 1618,
	"./assets/images/rebranding/products2/devops/primary.svg": 1619,
	"./assets/images/rebranding/products2/kuber/1.svg": 1620,
	"./assets/images/rebranding/products2/kuber/2.svg": 1621,
	"./assets/images/rebranding/products2/kuber/3.svg": 1622,
	"./assets/images/rebranding/products2/kuber/4.svg": 1623,
	"./assets/images/rebranding/products2/kuber/5.svg": 1624,
	"./assets/images/rebranding/products2/kuber/6.svg": 1625,
	"./assets/images/rebranding/products2/migration/1.svg": 1626,
	"./assets/images/rebranding/products2/migration/2.svg": 1627,
	"./assets/images/rebranding/products2/migration/3.svg": 1628,
	"./assets/images/rebranding/products2/migration/4.svg": 1629,
	"./assets/images/rebranding/products2/migration/5.svg": 1630,
	"./assets/images/rebranding/products2/migration/6.svg": 1631,
	"./assets/images/rebranding/products2/migration/primary.svg": 1632,
	"./assets/images/rebranding/products2/privateCloud/1.svg": 1633,
	"./assets/images/rebranding/products2/privateCloud/2.svg": 1634,
	"./assets/images/rebranding/products2/privateCloud/3.svg": 1635,
	"./assets/images/rebranding/products2/privateCloud/4.svg": 1636,
	"./assets/images/rebranding/products2/privateCloud/5.svg": 1637,
	"./assets/images/rebranding/products2/privateCloud/6.svg": 1638,
	"./assets/images/rebranding/products2/privateCloud/primary.svg": 1639,
	"./assets/images/rebranding/products2/productsPrimaryBackground.png": 1640,
	"./assets/images/rebranding/products2/secureCloud/1.svg": 1641,
	"./assets/images/rebranding/products2/secureCloud/2.svg": 1642,
	"./assets/images/rebranding/products2/secureCloud/3.svg": 1643,
	"./assets/images/rebranding/products2/secureCloud/4.svg": 1644,
	"./assets/images/rebranding/products2/secureCloud/5.svg": 1645,
	"./assets/images/rebranding/products2/secureCloud/6.svg": 1646,
	"./assets/images/rebranding/products2/secureCloud/primary.svg": 1647,
	"./assets/images/rebranding/products2/security/1.svg": 1648,
	"./assets/images/rebranding/products2/security/2.svg": 1649,
	"./assets/images/rebranding/products2/security/3.svg": 1650,
	"./assets/images/rebranding/products2/security/4.svg": 1651,
	"./assets/images/rebranding/products2/security/5.svg": 1652,
	"./assets/images/rebranding/products2/security/6.svg": 1653,
	"./assets/images/rebranding/products2/security/primary.svg": 1654,
	"./assets/images/rebranding/services/services-image.webp": 1655,
	"./assets/images/rebranding/statisticsBackground.webp": 1656,
	"./assets/images/sectionTwo/section1.svg": 2277,
	"./assets/images/security/1.svg": 1703,
	"./assets/images/security/10.svg": 1704,
	"./assets/images/security/11.svg": 1705,
	"./assets/images/security/12.svg": 1706,
	"./assets/images/security/13.svg": 1707,
	"./assets/images/security/14.svg": 1708,
	"./assets/images/security/15.svg": 1709,
	"./assets/images/security/16.svg": 1710,
	"./assets/images/security/17.svg": 1711,
	"./assets/images/security/18.svg": 1712,
	"./assets/images/security/2.svg": 1713,
	"./assets/images/security/3.svg": 1714,
	"./assets/images/security/4.svg": 1715,
	"./assets/images/security/5.svg": 1716,
	"./assets/images/security/6.svg": 1717,
	"./assets/images/security/7.svg": 1718,
	"./assets/images/security/8.svg": 1719,
	"./assets/images/security/9.svg": 1720,
	"./assets/images/security/WAF.svg": 1721,
	"./assets/images/security/ddos-ability.svg": 1722,
	"./assets/images/security/ddos-image.svg": 1545,
	"./assets/images/security/ddos.svg": 1723,
	"./assets/images/security/dlp.svg": 1724,
	"./assets/images/security/dmz.svg": 1725,
	"./assets/images/security/dr.svg": 1726,
	"./assets/images/security/firewall-ability.svg": 1727,
	"./assets/images/security/firewall-image.svg": 1546,
	"./assets/images/security/firewall-setting.svg": 1728,
	"./assets/images/security/firewall-web.svg": 1729,
	"./assets/images/security/firewall.svg": 1730,
	"./assets/images/security/header-image.svg": 1544,
	"./assets/images/security/hunezarat.svg": 1547,
	"./assets/images/security/iam.svg": 1731,
	"./assets/images/security/items-1.svg": 1732,
	"./assets/images/security/limitation.png": 1733,
	"./assets/images/security/limitation.svg": 1734,
	"./assets/images/security/private.svg": 1735,
	"./assets/images/security/sandbox.svg": 1736,
	"./assets/images/security/scan.svg": 1737,
	"./assets/images/security/sec2-mobile.svg": 1738,
	"./assets/images/security/sec2.svg": 1739,
	"./assets/images/security/siem.svg": 1740,
	"./assets/images/security/virus.svg": 1741,
	"./assets/images/security/waf-banner.svg": 1249,
	"./assets/images/service_icons/1.jpg": 2278,
	"./assets/images/service_icons/10.jpg": 2279,
	"./assets/images/service_icons/11.jpg": 2280,
	"./assets/images/service_icons/12.jpg": 2281,
	"./assets/images/service_icons/13.jpg": 2282,
	"./assets/images/service_icons/14.jpg": 2283,
	"./assets/images/service_icons/15.jpg": 2284,
	"./assets/images/service_icons/16.jpg": 2285,
	"./assets/images/service_icons/17.jpg": 2286,
	"./assets/images/service_icons/18.jpg": 2287,
	"./assets/images/service_icons/19.jpg": 2288,
	"./assets/images/service_icons/2.jpg": 2289,
	"./assets/images/service_icons/20.jpg": 2290,
	"./assets/images/service_icons/21.jpg": 2291,
	"./assets/images/service_icons/22.jpg": 2292,
	"./assets/images/service_icons/23.jpg": 2293,
	"./assets/images/service_icons/24.jpg": 2294,
	"./assets/images/service_icons/25.jpg": 2295,
	"./assets/images/service_icons/26.jpg": 2296,
	"./assets/images/service_icons/27.jpg": 2297,
	"./assets/images/service_icons/28.jpg": 2298,
	"./assets/images/service_icons/3.jpg": 2299,
	"./assets/images/service_icons/4.jpg": 2300,
	"./assets/images/service_icons/5.jpg": 2301,
	"./assets/images/service_icons/6.jpg": 2302,
	"./assets/images/service_icons/7.jpg": 2303,
	"./assets/images/service_icons/8.jpg": 2304,
	"./assets/images/service_icons/9.jpg": 2305,
	"./assets/images/slider.jpg": 2306,
	"./assets/images/solutions/digital-tahavol.svg": 1401,
	"./assets/images/solutions/organization-cloud.svg": 1402,
	"./assets/images/solutions/organization-security.svg": 1403,
	"./assets/images/solutions/organization-solutions.svg": 1404,
	"./assets/images/solutions/orgranization-services.svg": 1405,
	"./assets/images/svg/Banner.jpg": 2307,
	"./assets/images/svg/Group409.svg": 2308,
	"./assets/images/svg/Rectangle1.png": 2309,
	"./assets/images/svg/Rectangle2.png": 2310,
	"./assets/images/svg/Rectangle3.png": 2311,
	"./assets/images/svg/Rectangle4.png": 2312,
	"./assets/images/svg/benefit.svg": 697,
	"./assets/images/svg/cloud.svg": 676,
	"./assets/images/svg/not-found.png": 2313,
	"./assets/images/svg/plan.svg": 2314,
	"./assets/images/svg/slider-bg.svg": 1068,
	"./assets/images/videos/vpc-video.mp4": 2315,
	"./assets/images/videos/vps-video.mp4": 2316,
	"./assets/images/virtualServer/Feature-1.svg": 1254,
	"./assets/images/virtualServer/Feature-2.svg": 1255,
	"./assets/images/virtualServer/Feature-3.svg": 1256,
	"./assets/images/virtualServer/Feature-4.svg": 1257,
	"./assets/images/virtualServer/Feature-5.svg": 1258,
	"./assets/images/virtualServer/Feature-6.svg": 1259,
	"./assets/images/virtualServer/Feature-7.svg": 1260,
	"./assets/images/virtualServer/Feature-8.svg": 1261,
	"./assets/images/virtualServer/Step1-m.svg": 1187,
	"./assets/images/virtualServer/Step1.svg": 1188,
	"./assets/images/virtualServer/Step2-m.svg": 1107,
	"./assets/images/virtualServer/Step2.svg": 1108,
	"./assets/images/virtualServer/Step3.svg": 1109,
	"./assets/images/virtualServer/advancedSecurity.svg": 1262,
	"./assets/images/virtualServer/backup.svg": 1263,
	"./assets/images/virtualServer/easyBuy.svg": 1264,
	"./assets/images/virtualServer/easyUse.svg": 1265,
	"./assets/images/virtualServer/externalServer.svg": 1266,
	"./assets/images/virtualServer/focus.svg": 1267,
	"./assets/images/virtualServer/hosting.svg": 1268,
	"./assets/images/virtualServer/hourlyServer.svg": 1189,
	"./assets/images/virtualServer/iranServer.svg": 1269,
	"./assets/images/virtualServer/liveMigration.svg": 1270,
	"./assets/images/virtualServer/noLimit.svg": 1271,
	"./assets/images/virtualServer/reliability.svg": 1272,
	"./assets/images/virtualServer/siem.svg": 1273,
	"./assets/images/virtualServer/startupLoad.svg": 1274,
	"./assets/images/virtualServer/test.svg": 1275,
	"./assets/images/virtualServer/virtual-server.svg": 1085,
	"./assets/images/virtualServer/virtualDesktop.svg": 1276,
	"./assets/images/virtualServer/virtualOrganization.svg": 1277,
	"./assets/images/vps-icons/ManagedService-head.png": 2317,
	"./assets/images/vps-icons/ManagedService.png": 2318,
	"./assets/images/vps-icons/P1.png": 2319,
	"./assets/images/vps-icons/P2.png": 2320,
	"./assets/images/vps-icons/P3.png": 2321,
	"./assets/images/vps-icons/P4.png": 2322,
	"./assets/images/vps-icons/P5.png": 2323,
	"./assets/images/vps-icons/download.png": 2324,
	"./assets/images/vps-icons/file.png": 2325,
	"./assets/images/vps-icons/private-cloud.png": 1858,
	"./assets/images/vps-icons/private-icon.png": 1859,
	"./assets/images/vps-icons/vps.png": 2326,
	"./assets/images/vps-icons/vps_back.png": 2327,
	"./assets/images/vps-icons/vps_icon.png": 2328,
	"./assets/images/vps-icons/vps_icon2.png": 2329,
	"./assets/images/vps-icons/vps_icon_fix.png": 2330,
	"./assets/images/vps-icons/vps_icon_pic.png": 2331,
	"./assets/images/vps-icons/vps_ip.png": 2332,
	"./assets/images/vps-icons/vps_pattern.png": 2333,
	"./assets/images/vps-icons/vps_pattern2.png": 2334,
	"./assets/images/vps-icons/vps_picture.png": 2335,
	"./assets/images/vps-icons/vps_picture2.png": 2336,
	"./assets/images/vps-icons/vps_picture3.png": 2337,
	"./assets/images/vps-icons/vps_security.png": 2338,
	"./assets/images/vps-icons/vps_video.png": 2339,
	"./assets/images/vps-icons/vpss.png": 2340,
	"./assets/images/vps-icons/xaas-cloud.png": 2341,
	"./assets/images/windowsVps/24.svg": 1860,
	"./assets/images/windowsVps/Feature-1.svg": 1861,
	"./assets/images/windowsVps/Feature-3.svg": 1862,
	"./assets/images/windowsVps/benefit.svg": 1422,
	"./assets/images/windowsVps/centralized.svg": 1863,
	"./assets/images/windowsVps/chooseOs copy.svg": 1864,
	"./assets/images/windowsVps/chooseOs.svg": 1865,
	"./assets/images/windowsVps/configuration.svg": 1866,
	"./assets/images/windowsVps/console.svg": 1867,
	"./assets/images/windowsVps/dashboard.svg": 1868,
	"./assets/images/windowsVps/ddos-d.svg": 1869,
	"./assets/images/windowsVps/ddos.svg": 1870,
	"./assets/images/windowsVps/dr.svg": 1871,
	"./assets/images/windowsVps/freeSupport.svg": 1872,
	"./assets/images/windowsVps/global.svg": 1873,
	"./assets/images/windowsVps/hq.svg": 1874,
	"./assets/images/windowsVps/increase.svg": 1875,
	"./assets/images/windowsVps/infrustructure.svg": 1876,
	"./assets/images/windowsVps/list-vps.f735948 1.svg": 1877,
	"./assets/images/windowsVps/resource.svg": 1878,
	"./assets/images/windowsVps/sla.svg": 1879,
	"./assets/images/windowsVps/support.svg": 1880,
	"./assets/images/windowsVps/traffic-vps.aa00c67 1.svg": 1881,
	"./assets/images/windowsVps/waf-d.svg": 1882,
	"./assets/images/windowsVps/waf-icon-active.svg": 1883,
	"./assets/images/windowsVps/waf-icon.svg": 1884,
	"./assets/images/windowsVps/waf-vps.fcecd73 1.svg": 1885,
	"./assets/images/windowsVps/waf.svg": 1886,
	"./assets/images/xaas-gift.png": 2342,
	"./assets/images/xaas-icons/Hybrid Cloud.svg": 1409,
	"./assets/images/xaas-icons/Private Cloud.svg": 1408,
	"./assets/images/xaas-icons/Public Cloud.svg": 1407,
	"./assets/images/xaas-icons/datacenter.png": 2343,
	"./assets/images/xaas-icons/security.png": 2344,
	"./assets/images/xaas-icons/support.png": 2345,
	"./assets/images/xaas-icons/xaas-payment.png": 2346,
	"./assets/images/xaas-icons/xaas-period.png": 2347,
	"./assets/images/xaas-icons/xaas-scale.png": 2348,
	"./assets/images/xaas-icons/xaas-security.png": 2349,
	"./assets/images/xaas-icons/xaas-support.png": 2350,
	"./assets/text-styles.scss": 2351,
	"./assets/variables.scss": 2352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1826;